import { render } from "./AgendaTable.vue?vue&type=template&id=3ae932ff"
import script from "./AgendaTable.vue?vue&type=script&lang=js"
export * from "./AgendaTable.vue?vue&type=script&lang=js"

import "./AgendaTable.vue?vue&type=style&index=0&id=3ae932ff&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__